// Test server (Khorezmai test-env) da ishlayaptimizmi? Fail-closed: tezhal.uz domeni hech qachon test emas.
// Prod'da faqat-test bo'limlar (🧹 Test tozalash) menyuda ham, sahifada ham ko'rinmaydi.
export function isTestEnv() {
  const h = String(window.location.hostname || '').toLowerCase();
  if (!h || h.includes('tezhal.uz')) return false;
  return h.endsWith('.test.khorezmai.dev') || h === 'localhost' || h === '127.0.0.1';
}
